import React from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string } from 'yup';
import { CampaignGroupFormValues } from 'src/models/CampaignGroup.model';
import CampaignGroupForm from '../Layouts/CampaignGroupForm';
import { useAddCampaignGroupMutation } from 'src/services/CampaignGroup';
import { showToast } from 'src/utils/showToaster';

type Props = {
  onClose: () => void;
};

const AddCampaignGroupFormWrapper = ({ onClose }: Props) => {

  const [addCampaignGroup] = useAddCampaignGroupMutation()
  // Form Initial Values
  const initialValues: CampaignGroupFormValues = {
    campaignGroupName: '',
    channelLabel: '',
  };

  // Validation Schema
  const validationSchema = object().shape({
    campaignGroupName: string().required('Please campaign group name'),
    channelLabel: string().required('Please select channel'),
  });

  // Handle Submit
  const handleSubmit = (
    values: CampaignGroupFormValues,
    { setSubmitting, resetForm }: FormikHelpers<CampaignGroupFormValues>
  ) => {
    const formattedValues = {
      campaignGroupName: values?.campaignGroupName,
      channelId: values?.channelLabel
    }
    addCampaignGroup(formattedValues).then((res: any) => {
      if (res?.error) {
        showToast('error', res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast('success', res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast('error', res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth='xs' fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <CampaignGroupForm formikProps={formikProps} onClose={onClose} />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddCampaignGroupFormWrapper;